<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          Alapadatok
          <span>Felhasználó alapadatai</span>
        </h1>
      </div>
    </div>

    <div class="submenu clearfix">
      <div class="container">
        <ul>
          <li :class="{active: subpage == 'alapadatok'}">
            <a v-on:click="() => { subpage = 'alapadatok'}" href="javascript:void(0)">Alapadatok</a>
          </li>
          <li :class="{active: subpage == 'publikaciok'}">
            <a v-on:click="() => { subpage = 'publikaciok'}" href="javascript:void(0)">Publikációk</a>
          </li>
          <li :class="{active: subpage == 'adathozzajarulas'}">
            <a v-on:click="() => { subpage = 'adathozzajarulas'}" href="javascript:void(0)">Adathozzájárulás</a>
          </li>
        </ul>
      </div>
    </div>

    <Alapadatok v-if="subpage == 'alapadatok'" :showProgressInfo="showProgressInfo"/>
    <AdatHozzajarulas v-if="subpage == 'adathozzajarulas'" :showProgressInfo="showProgressInfo"/>
    <Publikaciok :changeSubPage="changeSubPage" v-if="subpage == 'publikaciok'"/>
    <Publikacio :showProgressInfo="showProgressInfo" :changeSubPage="changeSubPage" v-if="subpage == 'publikacio'"/>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
    <ProgressInfo :show="progressInfo" :hideProgressInfo="hideProgressInfo"/>

  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {
      subpage: 'alapadatok',
      progressInfo: false
    }
  },
  watch: {
    subpage: function() {
      $(document).scrollTop(0);
    },
    '$route.query.subpage': function(nv, ov) {
      this.subpage = nv;
    },
  },
  beforeMount: function() {

  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $('.autogrow').autogrow();
      $(window).scrollTop(0);

      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.subpage = this.$route.query.subpage;
  },
  methods: {
    showProgressInfo: function() {
      this.progressInfo = true;
    },
    hideProgressInfo: function() {
      this.progressInfo = true;
    },
    changeSubPage: function(page) {
      this.subpage = page;
    },
  }
}

Vue.component('Alapadatok', {
  props: ['changeSubPage', 'showProgressInfo'],
  data: function() {
    return {
      errors: [],
      name: this.$root.user.name
    };
  },
  template: `
    <section>
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <inputbox id="name" label="Név" :errors="errors" name="name" v-model="name"></inputbox>
            <div class="form-group">
              <label class="form-label">
                Neptun kód
              </label>
              <input type="text" name="neptunkod" value="" class="form-control"/>
            </div>
            <div class="form-group">
              <label class="form-label">
                Születési dátum
              </label>
              <input type="text" name="neptunkod" value="" class="form-control"/>
            </div>
            <div class="form-group">
              <label class="form-label">
                Email cím
              </label>
              <input type="text" name="neptunkod" value="" class="form-control"/>
            </div>
            <div class="form-group">
              <label class="form-label">
                Cím
              </label>
              <input type="text" name="neptunkod" value="" class="form-control"/>
            </div>
            <div class="form-group">
              <label class="form-label">
                Telefon
              </label>
              <input type="text" name="neptunkod" value="" class="form-control"/>
            </div>
            <div class="form-group">
              <label class="form-label">
                Életrajz információk
              </label>
              <textarea style="min-height: 200px" type="text" name="neptunkod" class="form-control autogrow"></textarea>
            </div>
            <div class="form-group">
              <button v-on:click="showProgressInfo" type="button" class="button save">Mentés</button>
            </div>
          </div>
        </div>

      </div>
    </section>
  `,
  mounted: function() {
  },
  methods: {
  }
});

Vue.component('AdatHozzajarulas', {
  props: ['changeSubPage', 'showProgressInfo'],
  data: function() {
    return {
      errors: [],
      combo: {
        items: [
          {
            value: 1,
            label: 'Oktatók'
          },
          {
            value: 2,
            label: 'Csak én'
          },
          {
            value: 3,
            label: 'Publikus'
          },
          {
            value: 4,
            label: 'Hallgatók'
          },
          {
            value: 5,
            label: 'Vezető oktatók'
          }
        ],
        selected: 1
      },
      combo2:{items:[{value:1,label:'Oktatók'},{value:2,label:'Csak én'},{value:3,label:'Publikus'},{value:4,label:'Hallgatók'},{value:5,label:'Vezető oktatók'}],selected:1},
      combo3:{items:[{value:1,label:'Oktatók'},{value:2,label:'Csak én'},{value:3,label:'Publikus'},{value:4,label:'Hallgatók'},{value:5,label:'Vezető oktatók'}],selected:3},
      combo4:{items:[{value:1,label:'Oktatók'},{value:2,label:'Csak én'},{value:3,label:'Publikus'},{value:4,label:'Hallgatók'},{value:5,label:'Vezető oktatók'}],selected:3},
      combo5:{items:[{value:1,label:'Oktatók'},{value:2,label:'Csak én'},{value:3,label:'Publikus'},{value:4,label:'Hallgatók'},{value:5,label:'Vezető oktatók'}],selected:5},
      combo6:{items:[{value:1,label:'Oktatók'},{value:2,label:'Csak én'},{value:3,label:'Publikus'},{value:4,label:'Hallgatók'},{value:5,label:'Vezető oktatók'}],selected:3},
      combo7:{items:[{value:1,label:'Oktatók'},{value:2,label:'Csak én'},{value:3,label:'Publikus'},{value:4,label:'Hallgatók'},{value:5,label:'Vezető oktatók'}],selected:1},
    };
  },
  template: `
    <section>
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <combobox id="nev" name="nev" label="Név" :errors="errors" v-model="combo3" />
            <combobox id="neptunkod" name="neptunkod" label="Neptun kód" :errors="errors" v-model="combo" />
            <combobox id="szd" name="szd" label="Születési dátum" :errors="errors" v-model="combo2" />
            <combobox id="email" name="email" label="Email cím" :errors="errors" v-model="combo3" />
            <combobox id="cim" name="cim" label="Cím" :errors="errors" v-model="combo5" />
            <combobox id="telefon" name="telefon" label="Telefon" :errors="errors" v-model="combo5" />
            <combobox id="kezdev" name="kezdev" label="Kezdés éve" :errors="errors" v-model="combo2" />
            <combobox id="lezfelev" name="lezfelev" label="Lezárt félévek" :errors="errors" v-model="combo7" />
            <combobox id="megszkredit" name="megszkredit" label="Megszerzett kreditek" :errors="errors" v-model="combo" />
            <combobox id="szakdcim" name="szakdcim" label="Szakdolgozat címe" :errors="errors" v-model="combo" />
            <combobox id="szakdert" name="szakdert" label="Szakdolgozat értékelése" :errors="errors" v-model="combo2" />
          </div>
          <div class="col-sm-6">
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <button v-on:click="showProgressInfo" type="button" class="button save">Mentés</button>
            </div>
          </div>
        </div>

      </div>
    </section>
  `,
  watch: {
    'combo.selected': function(nv, ov) {
      if (nv == 2) {
        $('#nev').addClass('locked');
      } else {
        $('#nev').removeClass('locked');
      }
    }
  },
  mounted: function() {
  },
  methods: {
  }
});

Vue.component('Publikaciok', {
  props: ['changeSubPage'],
  data: function() {
    return {
      items: [
        {
          id: 1,
          name: 'Non nemo pede odio wisi dolor habitant',
          date: '2017.08.25.'
        },
        {
          id: 2,
          name: 'Praesent dictum massa sit amet arcu porttitor',
          date: '2016.02.10.'
        },
        {
          id: 3,
          name: 'Proin tempus leo feugiat tellus vulputate sollicitudin.',
          date: '2015.03.07.'
        }
      ]
    };
  },
  template: `
    <section>
      <div class="container">
        <div class="profile-publication-item" v-for="(item, i) in items">
          <div class="text">
            <i class="fa fa-file-o"></i> {{ item.name }}<span class="date"><i class="fa fa-clock-o"></i>{{ item.date }}</span>
          </div>
          <div class="links">
            <a href="#" class="link v1">
              <i class="fa fa-pencil"></i>
            </a>
            <a href="#" class="link v2">
              <i class="fa fa-trash-o"></i>
            </a>
          </div>
        </div>
        <a style="margin-top:30px" href="javascript:void(0)" v-on:click="changeSubPage('publikacio')" class="button v2"><i class="fa fa-plus"></i> Új publikáció feltöltése</a>
      </div>
    </section>
  `,
  mounted: function() {
  },
  methods: {
  }
});

Vue.component('Publikacio', {
  props: ['changeSubPage', 'showProgressInfo'],
  data: function() {
    return {
      errors: [],
      megnevezes: '',
      mtmt_link: '',
      leiras: '',
      datum: '',
      public: {
        value: 1,
        selected: false
      },
      docs: [
      ]
    };
  },
  template: `
    <section>
      <div class="container">
        <a href="javascript:void(0)" v-on:click="changeSubPage('publikaciok')" class="back-button"><img src="assets/img/grey-arrow.png" alt=""/>Vissza</a>
        <div class="row">
          <div class="col-sm-5">
            <h5>Publikáció szerkesztése</h5>
            <inputbox id="megnevezes" label="Megnevezés" :errors="errors" name="megnevezes" v-model="megnevezes"></inputbox>
            <inputbox id="mtmt_link" label="MTMT link" :errors="errors" name="mtmt_link" v-model="mtmt_link"></inputbox>
            <textareabox id="leiras" label="Absztrakt" :errors="errors" name="leiras" v-model="leiras"></textareabox>
            <inputbox :datepicker="true" id="datum" label="Dátum" :errors="errors" name="datum" v-model="datum"></inputbox>
            <toggle id="public" label="Publikus" v-bind:errors="errors" name="public" v-model="public"></toggle>
          </div>
          <div class="col-sm-7">
            <h5>Feltöltött dokumentumok</h5>
            <div v-if="docs.length > 0" class="profile-publication-item" v-for="(doc, i) in docs">
              <div class="text">
                <i class="fa fa-file-o"></i> {{ doc.name }}
              </div>
              <div class="links">
                <a v-on:click="deleteDocument" href="javascript:void(0)" class="link v2"><i class="fa fa-trash-o"></i></a>
              </div>
            </div>
            <div v-if="docs.length == 0" class="info-box warning"><span class="highlight">Figyelem!</span> Ön még nem töltött fel dokumentumot.</div>
            <div v-on:dblclick="addDocument" class="upload-zone">
              <i class="fa fa-cloud-upload"></i>
              Új dokumentum feltöltés
              <span>Húzza ide a feltöltendő fájlt</span>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <button v-on:click="showProgressInfo" type="button" class="button save">Mentés</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
  mounted: function() {
  },
  methods: {
    deleteDocument: function() {
      this.docs = [];
    },
    addDocument: function() {
      this.docs.push({
        id: 1,
        name: 'Nullam eget mi sit amet neque scelerisque feugiat'
      });
    }
  }
});
</script>




// WEBPACK FOOTER //
// profilepage.vue?b300a6d6